import { createSlice } from '@reduxjs/toolkit';
import { getJobLogs } from 'ducks/logs/operators';
import { normalizeLogs } from 'ducks/logs/utils';
import { Slices } from 'ducks/slices';
import { LogsItem } from 'ducks/types/store-types';

export type LogsState = LogsItem[];

const initialState: LogsState = [];

const logsSlice = createSlice({
  name: Slices.LOGS,
  initialState,
  reducers: {
    clearLogs: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobLogs.pending, () => {
        return initialState;
      })
      .addCase(getJobLogs.fulfilled, (_, { payload }) => {
        return normalizeLogs(payload);
      })
      .addCase(getJobLogs.rejected, () => {
        return initialState;
      });
  },
});

export const { clearLogs } = logsSlice.actions;

export default logsSlice.reducer;
